I18n.translations.JA = {
	loading: 'loading...',
	developed_by: 'developed by',
	back: 'Back',
	yes: 'はい',
	no: 'No',
	ok: 'OK',
	connection_error: 'Problem with connection',
	connection_down: 'An error has occurred related to your Internet connection.',
	connection_up: 'Internet connection has been restored.',
	error: 'エラー:',
	timeout: 'Request timeout',
	player_error: 'Error with playing',
	err_config_fetch: 'Unable to load the API config.',
	err_throbber_timeout: 'Something is taking way too long, try again after a few minutes.',
	playback_error_message: 'An error has occurred related to video playback',
	please_sign_in: 'Please enter your account to sign in',
	enter_your_email: 'Enter your e-mail address',
	enter_your_password: 'Enter your password',
	email: 'Eメール',
	password: 'パスワード',
	continue: 'Continue',
	skip_this_step: 'Skip this step',
	not_registred_yet: 'Not registered yet?',
	please_go_to: 'Please go to',
	lets_watch: 'Let\'s watch',
	invalid_credentials: 'Invalid credentials.',
	invalid_email: 'Please enter valid email.',
	invalid_password: 'Please enter valid password.',
	full_description: 'Full description',
	close_description: 'Close description',
	go_back: 'Go back',
	sign_in: "ログイン",
    sign_out: "ログアウト",
	min: '分',
	no_Url: 'No Url',
	err_data_fetch: 'Data fetching or parsing failed',
	dialog_exit_title: 'Exit',
	dialog_exit_content: 'Would you like to exit the app?',
	token_expired:"Your login session has expired, please sign in.",
    issue_login:"If you're experiencing issues while using this app, please contact from 9AM to 6PM by email to: subscribers@allflamenco.net.",
	search: "Search by title, actor, director or author",
	search_title: "検索",
    results: '次の検索結果が見つかりました "',
	go_back_catalog: 'Back to catalog',
	my_account: 'マイアカウント',
	login_title: 'Webブラウザーからログイン',
	login_line1: 'スマートフォン、またはパソコンから下記にアクセス ',
	login_line2: 'ALL FLAMENCOにログイン、またはサインアップする',
	login_line3: '下記のコードを入力',
	name: '名前',
	session: 'SESSION',
	subscription: '購入',
	no_subscription: '購入されたものはありません',
	spacebar: 'スペースキー',
	play: '今すぐ再生',
	add_favorites: 'お気に入りに追加',
	remove_favorites: 'お気に入りから削除',
	favorites: 'お気に入り',
	continue_watching: '視聴を再開する',
	requires_subscription: 'To gain access to this content, please refer to app.allflamenco.net',
	detail_ARTISTS: '出演アーティスト',
	detail_YEAR: '制作年',
	detail_RATING: '視聴年齢区分',
	detail_STYLE: '曲種／楽曲スタイル',
	detail_GENRE: 'ジャンル',
	detail_LANGUAGE: '言語',
	detail_LOC_CITY: '地名',
	detail_LOC_PLACE: '場所',
	detail_TYPE: 'タイプ',
	detail_SEASON: 'シーズン',
	detail_EPISODE: 'チャプター',
	detail_SERIES: 'パート', 
	detail_DURATION: '再生時間',
	detail_DESCRIPTION: '説明',
	purchases: '購入',
	sub_active: 'Active subscription',
	sub_inactive: '購入されたものはありません'
};


//////////////////
// WEBPACK FOOTER
// ./js/i18n/ja.js
// module id = 43
// module chunks = 0